// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-left-right-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.5 4L19 7.5L15.5 11M17.75 7.5H5.5M8.5 20L5 16.5L8.5 13M6.25 16.5H18.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowLeftRight1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-left-right-1',
    ref,
    icon: element,
  },
));

ArrowLeftRight1Icon.displayName = 'ArrowLeftRight1Icon';

export default ArrowLeftRight1Icon;
